/**
 * StudySync Footer Component
 * Simple footer with branding and links
 */

import React from "react";
import {
  Box,
  Container,
  Typography,
  Divider,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#8C1515",
        py: 3,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              component="img"
              src="/finalized_logo/Study Sync Short Logo Footer.svg"
              alt="StudySync"
              sx={{
                height: 28,
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 1, sm: 3 },
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontSize: "0.875rem", color: "rgba(255, 255, 255, 0.85)" }}
            >
              Copyright {currentYear} StudySync Research Platform
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <MuiLink
                component={RouterLink}
                to="/privacy-policy"
                underline="hover"
                sx={{
                  color: "rgba(255, 255, 255, 0.85)",
                  fontSize: "0.875rem",
                }}
              >
                Privacy Policy
              </MuiLink>
              <MuiLink
                component={RouterLink}
                to="/terms-of-service"
                underline="hover"
                sx={{
                  color: "rgba(255, 255, 255, 0.85)",
                  fontSize: "0.875rem",
                }}
              >
                Terms of Service
              </MuiLink>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 2, borderColor: "rgba(255, 255, 255, 0.2)" }} />

        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "center",
            fontSize: "0.75rem",
            color: "rgba(255, 255, 255, 0.7)",
          }}
        >
          Secure research platform for health data collection and analysis.
          Built with privacy and compliance in mind.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
